// extracted by mini-css-extract-plugin
export default {"tableButtons":"index-module__tableButtons--af9jd"};